import PropTypes from "prop-types";
// form
import { useFormContext, Controller } from "react-hook-form";
// @mui
import { DateTimePicker } from "@mui/lab";
import { TextField } from "@mui/material";

// ----------------------------------------------------------------------

RHFDateTimePicker.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
};

export default function RHFDateTimePicker({ name, label, ...other }) {
  const { control, watch } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <DateTimePicker
          {...field}
          fullWidth
          error={!!error}
          helperText={error?.message}
          value={watch(name)}
          renderInput={(params) => (
            <TextField {...params} label={label} fullWidth />
          )}
          {...other}
        />
      )}
    />
  );
}
